import components from './components';
import { track } from './directives/track';
import PlatformRoutes from './routes';
import { AlertsService } from './services/alertsService';
import { AnalyticsService } from './services/analyticsService';
import { ApplicationsService } from './services/applicationsService';
import { NotificationsService } from './services/notificationsService';
import alerts from './store/alerts';
import {
  ApplicationsModule,
  NAMESPACE as APPLICATIONS_NAMESPACE,
  SET_ERROR_GENERAL,
  SET_LOADING_GENERAL,
} from './store/applications';
import { NotificationsModule } from './store/notifications';
import http from './utils/http';

const VuePortal = require('@linusborg/vue-simple-portal');

/**
 * Function to install module in Vue instance
 * @params {Object} Vue: Vue instance
 * @params {Object} settings: object who contains router and store instance
 * */
export function install(Vue, settings) {
  Vue.use(VuePortal, {
    name: 'portal',
  });

  if (!settings || !settings.store || !settings.router || !settings.services) {
    throw new Error(
      'Please initialise plugin with a Vuex store, a Vue router and a PiivoServices.'
    );
  }

  settings.router.addRoutes(PlatformRoutes);
  settings.store.registerModule('alerts', alerts.AlertsModule);
  settings.store.registerModule('notifications', NotificationsModule);

  if (settings.store.state[APPLICATIONS_NAMESPACE]) {
    settings.store.registerModule(APPLICATIONS_NAMESPACE, ApplicationsModule, {
      preserveState: true,
    });
  } else {
    settings.store.registerModule(APPLICATIONS_NAMESPACE, ApplicationsModule);
  }
  // Make sure to init general state asap, in case previous version of module was in localStorage
  settings.store.commit(`${APPLICATIONS_NAMESPACE}/${SET_LOADING_GENERAL}`, {
    loadingState: false,
  });
  settings.store.commit(`${APPLICATIONS_NAMESPACE}/${SET_ERROR_GENERAL}`, {
    errorState: false,
  });

  components.map(component => {
    Vue.component(component.name, component);
  });

  Vue.directive('track', track);

  Vue.use(http);

  /* Install services */
  settings.services.addService('alerts', new AlertsService());
  settings.services.addService('notifications', new NotificationsService());
  settings.services.addService('analytics', new AnalyticsService());
  settings.services.addService('applications', new ApplicationsService());
}

export default install;
